<template>
  <div class="deliveriesList" @scroll="continuesscroll">
        <div class="deliveries assignedWrap">
            <b-container>
                <template v-for="order in pendingrequests">
                    <div 
                        v-if="checkstatus(order, 'assign')"
                        :key="order.id" 
                        class="deliveryItem assigned">
                        <b-row no-gutters>
                            <b-col cols="2" md="2">
                                    <div 
                                        @click="openMap('drive', order.order)"
                                        class="googleMap">
                                    <GmapMap
                                        :options="mapOptions"
                                        :center="{
                                                    lat: parseFloat(order.order.shipping_address_latitude),
                                                    lng: parseFloat(order.order.shipping_address_longitude)
                                                }"
                                        :zoom="10"
                                        map-type-id="roadmap"
                                    >
                                        <GmapMarker
                                            :icon="svgMarker"
                                            :position="{
                                                    lat: parseFloat(order.order.shipping_address_latitude),
                                                    lng: parseFloat(order.order.shipping_address_longitude)
                                                }"
                                        />
                                    </GmapMap>
                                </div>
                            </b-col>


                            <b-col cols="7" md="7">
                                <div class="deliveryDateandTime">
                                    <div class="ddate">
                                        <b-icon icon="calendar"></b-icon> {{order.order.order_event_time_range ? `${order.order.order_event_time_range}, ` : ''}} {{order.order.delivery_date | formatdate('MMM D')}}
                                    </div>

                                    <div class="dAddress">
                                        <b-icon icon="geo-alt"></b-icon> {{order.order.shipping_address_street}} {{order.order.shipping_address_city}} {{order.order.shipping_address_state}} {{order.order.shipping_address_zipcode}}
                                    </div>
                                </div>
                            </b-col>

                            <b-col cols="3" md="3">

                                <div class="deliveryAction">
                                    <div 
                                        @click="acceptrejectorder(order, 'reject')"
                                        class="deliveryActionItem">
                                        
                                        <span class="decline">
                                            <b-icon icon="x-circle"></b-icon>
                                        </span>
                                    </div>
                                    
                                    <div 
                                        @click="acceptrejectorder(order, 'accepted')"
                                        class="deliveryActionItem">
                                        <span class="accept">
                                            <b-icon icon="check"></b-icon>
                                        </span>
                                    </div>

                                </div>
                            </b-col>
                        </b-row>

                    </div>
                </template>
            </b-container>
        </div>
        
      
        <mobile-delivery-list
            v-if="['sm','xs','md'].includes(windowsize.breakpoint)"
            :ordergroup="ordergroup" />

        <desktop-delivery-list
            v-if="['lg','xl','xxl'].includes(windowsize.breakpoint)"
            :ordergroup="ordergroup" />
  </div>
</template>

<script>

/**
 * Declerations
 */

// Plugins
import axios from 'axios'
import moment from 'moment'
// import _ from 'lodash'

// mixins
import {mapMixins} from '@/mixins/mapMixins';
import {ordermixins} from '@/mixins/ordermixins'

// helpers
import { addUpdateCollection, newJob, updatecollections} from '@/helpers/localbase'
import Helper from '@/helpers/helper'

// components
import mobiledeliverylist from '@/components/employee/mobiledeliverylist'
import desktopdeliverylist from '@/components/employee/desktopdeliverylist'

export default {
    mixins : [mapMixins, ordermixins],
    components : {
        'mobile-delivery-list' : mobiledeliverylist,
        'desktop-delivery-list': desktopdeliverylist
    },
    data() {
        return {
            showAssignPop  : false,
            ordergroup     : [],
            orders         : [],
            pendingrequests: [],
            fetching       : false,
            currentpage    : null,
            overdueorders  : []
        }
    },
    computed : {
        /**
         * Window size
         */
        windowsize() {
            return this.$store.state.windowsize
        },
        /**
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        },
        /**
         * Loggedinuser
         */
        user() {
            return this.$store.state.user
        },
        /**
         * Socketio / Webhook connection
         */
        socketio() {
            return this.$store.state.socketio
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Continues scroll 
         * fetch unassign list pages when scrolling
         */
        continuesscroll() {
            if(!this.fetching) {
                if(this.currentpage.next_page_url) {
                    this.getallassignedorders(true)
                }
            }
        } ,
        
        /**
         * Check if order status is accepted
         * @param order
         * @param status
         */
        checkstatus(order, status) {
            if(status == 'accepted') {
                return order.order.status == 'accepted' || order.order.status == 'amend' ? true : false
            } else {
                return order.order.status == status ? true : false
            }
        },
        /**
         * Accept / reject assigned order
         */
        async acceptrejectorder(order, status) {
            
            /**
             * Remove from the list the accepted order
             */
            this.pendingrequests = this.pendingrequests.filter(pendingorder => pendingorder.order.id != order.order.id)
           

           /**
            * Process request base on status
            */

           
           if(status == 'accepted') {

                /**
                 * Process background
                 */

                const url = `/update_order_status/${order.order.id}`
                const res = await axios.post(url, {
                    status    : status,
                    updated_by: this.user.id
                }).catch(err => console.log(err))

                if(res && res.data) {

                    // add response to order status 
                    let orders = this.orders.map(o => {
                        if(o.order_id == order.order.id) {
                            // const status = o.order.orderstatuses;
                            // status.status = 'accepted'
                            o.order.orderstatuses = [...o.order.orderstatuses, res.data.data]
                            o.order.status        = 'accepted'

                            /**
                             * Update indexed db collection
                             */
                            addUpdateCollection({name : 'assignedorders', data : o})
                        }
                        return o;
                    })

                    this.orders = orders
    
                    this.socketio.emit('broadcast', {
                        type : 'acceptedassign'
                    })
    
                    // emit to parent updating list on other component
                    this.$emit('update')
                }

    
            } else if(status == 'reject') {
                const url = `/unassign_order/${order.order.id}`
                await axios.post(url, {
                    assign_to : order.assign_to.id
                })

                const urlstatus = `/update_order_status/${order.order.id}`
                const res = await axios.post(urlstatus, {
                    status    : 'rejected',
                    updated_by: this.user.id
                })

                if(res && res.data) {
                    // add response to order status 
                    let orders = this.orders.map(o => {
                        if(o.order_id == order.order.id) {
                            o.order.orderstatuses = [res.data.data, ...o.order.orderstatuses]
                        }
                        return o;
                    })

                    this.orders = orders
                }

                this.socketio.emit('broadcast', {
                    type : 'rejectassigned'
                })
            }

            this.grouporders();
        },
        /**
         * Socket io / webhook listner
         * update order list
         */
        socketlistener() {
            if(!this.socketio) return ;

            this.socketio.on('broadcast', async data => {
                if(data && this.user) {
                    if(data.type == 'assignorder', this.user.id == data.userid) {
                        await this.getallassignedorders();

                         // get unread notif
                        this.$store.dispatch('getunreadnotifs')

                        // emit to parent updating list on other component
                        this.$emit('update')
                    }
                }
            })
        },
       
        /**
         * Group order by dates
         */
        grouporders() {
            /**
             * Get orver due orders and insert to the groups
             */
            this.overdueorders = this.orders.filter(order => moment(Helper.formatdate(order.order.delivery_date, 'MM/DD/YYYY')).isBefore(Helper.formatdate(moment(), 'MM/DD/YYYY', true)))
            let group = this.grouporderbydates(this.orders)

            group.unshift({
                date  : 'pastdue',
                orders: this.overdueorders
            })

            // if(group.length >= 2) {
            //     group.splice(2,0 , {
            //         date  : 'pastdue',
            //         orders: this.overdueorders
            //     })
            // } else {
            //     group = [...group, {
            //         date  : 'pastdue',
            //         orders: this.overdueorders
            //     }]
            // }
            
            this.ordergroup = group
        },
        /**
         * Get assigned  orders
         * pull from indexed db fist
         */
        async getallassignedorders (nextpage = false) {
            this.fetching = true
            // const iorders = await getCollections({name : 'assignedorders'})
            // this.orders = iorders.filter(o => o.assign_to.id == this.user.id);
             /**
             * Group order by date
             */
            // this.grouporders();

            

            /**
             * api requires
             */
            let params = {
                page : 1
            }

            if(nextpage) {
                params.page = this.currentpage.current_page + 1
            }


            const url = '/get_driver_orders'
            const res = await axios.get(url, {params : params}).catch(err => console.log(err));

            if(res && res.data) {
                this.currentpage = res.data
                let newdata = res.data.data
                this.orders = [...this.orders, ...newdata]
                // let nextpage = res.data.next_page_url

                // while(nextpage) {
                //     const newres = await axios.get(nextpage).catch(err => console.log(err));
                //     if(newres.data) {
                //         nextpage = newres.next_page_url
                //         newdata = [...newdata, ...newres.data.data]
                //     } else {
                //         nextpage = null;
                //     }
                // }
                
                /**
                 * Get all assigned order for this employee
                 */
                // this.orders = newdata.filter(o => o.assign_to.id == this.user.id);

                /**
                 * Get all pending request
                 * and they should be today and future dates
                 */
                this.pendingrequests = this.orders.filter(order => order.order.status == 'assign');

                /**
                 * Update indexed db
                 * and clean trashed data
                 */
                // this.orders.forEach(d => {
                //     addUpdateCollection({name : 'assignedorders', data : d})
                // })

                // cleanup
                // cleanrecord(newdata, iorders, 'id', 'assignedorders')

               


            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 */

                newJob({
                    url   : url,
                    method: "GET",
                    callback : async (data, options) => {
                        if(data) {
                            let newdata  = data.data
                            let nextpage = data.next_page_url

                            while(nextpage) {
                                const newres = await axios.get(nextpage).catch(err => console.log(err));
                                if(newres.data) {
                                    nextpage = newres.next_page_url
                                    newdata = [...newdata, ...newres.data.data]
                                } else {
                                    nextpage = null;
                                }
                            }

                            /**
                             * Update indexed db
                             * and clean trashed data
                             */
                            newdata.forEach(d => {
                                options.db.addUpdateCollection({name : 'assignedorders', data : d})
                            })
                        }
                    }
                })
            }

            /**
             * Group order by date
             */
            updatecollections({datas : this.orders, name : 'assignedorders'})

            this.grouporders();

            this.fetching = false
        }

    },
    /**
     * Run function before component rendered
     */
    beforeMount() {
        // Initialize google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });

    },
    /**
     * Run function after component rendered
     */
    async mounted() {
        // socket listner
        this.socketlistener();
        // get assigned orders
        await this.getallassignedorders();
        await this.getallassignedorders(true);
    }
}
</script>

<style lang='scss'>
@import '@/scss/partials/_mixins.scss';
@import '@/scss/partials/_colors.scss';

.deliveriesList {
    max-height: 87vh;
    overflow  : hidden auto;

     h3 {
        color        : $primaryColor;
        font-size    : 15px;
        font-weight  : 700;
        margin-bottom: 20px;
    }

     .itemSize  {
            width           : 60px;
            height          : 60px;
            border-radius   : 100%;
            display         : flex;
            flex-direction  : column;
            align-items     : center;
            justify-content : center;
            background-color: $lightgrey3;
            margin-right    : 15px;

            span {
                display    : block;
                font-weight: 800;

                &:last-child {
                    font-size : 10px;
                }
            }
        }

    .deliveries {
        border-bottom : 10px solid $lightgrey;
        padding : 30px 0;

        &.assignedWrap {
            border          : none;
            background-color: $grey;
            padding         : 0;
        }
        

       
        
        .deliveryItem {
            border-bottom : 1px solid $lightgrey2;
            padding-bottom: 15px;
            padding-top   : 15px;
            cursor        : pointer;

            &.assigned {
                
                @include screen-up(md) {
                    padding : 30px 15px;
                }

                @include screen-up(sm) {
                    padding : 15px 0;
                }

                .deliveryDateandTime {
                    color          : white;
                    height         : 100%;
                    justify-content: center;
                    display        : flex;
                    flex-direction : column;
                    padding-left   : 10px;
                }
            }
            

            &:last-child {
                border-color : transparent;
            }

            .deliveryAction {
                display        : flex;
                align-items    : center;
                justify-content: flex-end;

                .deliveryActionItem {
                    margin-left: 10px;
                    font-size  : 30px;

                    .decline {
                        color : white;
                    }

                    .accept {
                        color           : $primaryColor;
                        background-color: white;
                        width           : 30px;
                        height          : 30px;
                        border-radius   : 100%;
                        display         : block;
                        padding         : 0;
                        display         : flex;
                        align-items     : center;
                        justify-content : center;
                    }
                }
            }

            .googleMap {
                * {
                    pointer-events: none;
                }
            }

            .vue-map-container {
                min-height: 60px;;
                height    : 100%;
            }

            .OrderInfo {
                display: flex;
    
               
    
                .orderName {
                    margin-bottom : 10px;
                    
                    h2 {
                        font-size    : 17px;
                        font-weight  : 800;
                        margin-bottom: 0;
                    }
    
                    p {
                        color : $grey;
                        font-size : 12px;
                    }
                }
            }

            .deliveryInfo {
                color : $grey;

                .deliverAssign {
                    font-size      : 40px;
                    display        : flex;
                    justify-content: flex-end;
                    cursor         : pointer;
                }

            }

            .deliveryDateandTime {
                font-size : 12px;

                .ddate {
                    margin-bottom : 5px;
                }
            }
        }
    }

    

}
</style>